import { styled } from "@mui/material";
import { useRef } from "react";
import { useContainerDimensions } from "../../../hooks/others/useContainerDimensions";
import { useCarouselTextAnimation } from "../../../hooks/others/useCarouselTextAnimation";
import { isMobile } from "react-device-detect";

const HiddenContainer = styled('div')(() => ({
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    boxSizing: 'border-box',
    position: 'relative'
}));

const AnimatedContainer = styled('div')(({animation}) => ({
    display: 'inline-block',
    animation: animation,
    animationPlayState: isMobile ? 'running' : 'paused',
    position: 'relative',
    paddingInline: '0.25rem 1rem',
    '&:hover': {
        animationPlayState: 'running'
    }
}));

const CarouselText = ({children, maxWidth = 0}) => {
    const ref = useRef(null);
    const { width } = useContainerDimensions(ref);
    const animation = useCarouselTextAnimation(width, maxWidth);
    return (
        <HiddenContainer>
            <AnimatedContainer animation={animation} >
                <div ref={ref}>
                    {children}
                </div>
            </AnimatedContainer>
        </HiddenContainer>
    )
}

export default CarouselText;